document.addEventListener('DOMContentLoaded', function() {
  sal();
  scrollButtons();
  menuButtonHandler();
  footerDropdown();
});

function footerDropdown() {
  const button = document.querySelector('.dropdown--links .title'); 
  function toggleLinks() {
    document.querySelector('.dropdown--links').classList.toggle('active');
  }
  button.addEventListener('click', toggleLinks);
}

function scrollButtons() {
  const buttons = document.querySelectorAll('.scroll-button');

  function scrollToSection(event) {
    const targetId = event.currentTarget.getAttribute('data-scroll-to');
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  }

  buttons.forEach(button => {
    button.addEventListener('click', scrollToSection);
  });
}


function menuButtonHandler() {
  const menuButtons = document.querySelectorAll('.open--menu');
  const close = document.querySelector('.menu--overlay .close');
  function openMenu() {
    document.body.classList.add('menu-open');
  }
  function closeMenu() {
    document.body.classList.remove('menu-open');
  }
  menuButtons.forEach(button => {
    button.addEventListener('click', openMenu);
  });
  close.addEventListener('click', closeMenu);
}
